import React, { useState, useEffect } from 'react';
import { fetchAgents as fetchAgentsAPI, fetchAgentById, deleteAgent, fetchProfile as fetchProfileAPI } from '../utils/api';
import { ADMIN_ROLE, PARTNERSHIPS_STAFF } from '../utils/roles';
import { mapErrorMessage } from '../utils/errorMapping';
import AgentDetailModal from './AgentDetailModal';
import CreateAgentModal from './CreateAgentModal';
import EditAgentModal from './EditAgentModal';
import './_UserTiles.css';
import './_Buttons.css';

const Agents = () => {
    const [agents, setAgents] = useState([]);
    const [totalAgents, setTotalAgents] = useState(0);
    const [error, setError] = useState('');
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateModalOpen, setCreateModalOpen] = useState(false);
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [profile, setProfile] = useState(null);

    const fetchAgents = async () => {
        try {
            const data = await fetchAgentsAPI();
            setAgents(data.data || []);
            setTotalAgents(data.total || 0);
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                const profileData = await fetchProfileAPI();
                setProfile(profileData.data);
                fetchAgents();
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };

        loadData();
    }, []);

    const handleCardClick = async (agentId) => {
        try {
            const response = await fetchAgentById(agentId);
            setSelectedAgent(response.data);
            setIsModalOpen(true);
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedAgent(null);
    };

    const handleOpenCreateModal = () => {
        setCreateModalOpen(true);
    };

    const handleCloseCreateModal = () => {
        setCreateModalOpen(false);
    };

    const handleAgentCreated = () => {
        fetchAgents();
        handleCloseCreateModal();
    };

    const handleOpenEditModal = (agent) => {
        setSelectedAgent(agent);
        setEditModalOpen(true);
        setIsModalOpen(false);
    };

    const handleCloseEditModal = () => {
        setEditModalOpen(false);
        setSelectedAgent(null);
    };

    const handleAgentUpdated = () => {
        fetchAgents();
        handleCloseEditModal();
    };

    const handleAgentUpdate = async () => {
        fetchAgents();
        if (selectedAgent) {
            try {
                const updatedAgent = await fetchAgentById(selectedAgent.id);
                setSelectedAgent(updatedAgent.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        }
    };

    const handleDeleteAgent = async (agentId) => {
        if (window.confirm('Are you sure you want to delete this agent?')) {
            try {
                await deleteAgent(agentId);
                fetchAgents();
                handleCloseModal();
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        }
    };
 
    const canManageAgents = profile && profile.roles.some(role => role.id === ADMIN_ROLE || role.id === PARTNERSHIPS_STAFF);
 
     return (
        <div className="students-container">
            <div className='user-tiles'>
                <h1>Agents | {totalAgents}</h1>
                {canManageAgents && (
                    <button onClick={handleOpenCreateModal} className="add-student-button">+</button>
                )}
            </div>
            {error && <p className="error">{error}</p>}
            <div className="user-tiles-container">
                {agents.map(agent => (
                    <div key={agent.id} className="user-tile" onClick={() => handleCardClick(agent.id)}>
                        <h2>{agent.name}</h2>
                        <p>{agent.email}</p>
                        <p>Phone: {agent.phone}</p>
                        <p>Contact: {agent.contact_name}</p>
                    </div>
                ))}
            </div>
            {isModalOpen && <AgentDetailModal agent={selectedAgent} onClose={handleCloseModal} onEdit={handleOpenEditModal} onDelete={handleDeleteAgent} canManage={canManageAgents} onAgentUpdate={handleAgentUpdate} />}
            {isCreateModalOpen && (
                <CreateAgentModal
                    onClose={handleCloseCreateModal}
                    onAgentCreated={handleAgentCreated}
                />
            )}
            {isEditModalOpen && (
                <EditAgentModal
                    agent={selectedAgent}
                    onClose={handleCloseEditModal}
                    onAgentUpdated={handleAgentUpdated}
                />
            )}
        </div>
    );
};

export default Agents;